import types from "./types";

export const getSubscriptionPlan = (payload) => ({type: types.GET_SUBSCRIPTION, payload})
export const getSubscriptionPlanResp = (payload) => ({
    type: types.GET_SUBSCRIPTION_RESP, payload
})
export const getSubscriptionPlanClear = () => ({type: types.GET_SUBSCRIPTION_CLEAR})


export const getTestimonalData = (payload) => ({type: types.GET_TESTIMONAL, payload})
export const getTestimonalDataResp = (payload) => ({
    type: types.GET_TESTIMONAL_RESP, payload
})
export const getTestimonalDataClear = () => ({type: types.GET_TESTIMONAL_CLEAR})

export const getSubscriptionDetails = (payload) => ({type: types.GET_SUBSCRIPTION_DETAILS, payload})
export const getSubscriptionDetailsResp = (payload) => ({
    type: types.GET_SUBSCRIPTION_DETAILS_RESP, payload
})
export const getSubscriptionDetailsClear = () => ({type: types.GET_SUBSCRIPTION_DETAILS_CLEAR})